// QR Kiosk v2 — full-width "You're offline" strip (rendered from the layout slot).
// Ported from designer kiosk2-screens.jsx `OfflineBar`. Tokens only.
// KV2-0 ships the component + conditional render; the navigator.onLine listener
// that flips state.kioskV2.offline is KV2-5 scope — so with no writer this never
// shows in KV2-0, which is correct. Sticky under the 50px chrome.
import React from "react";
import useTranslation from "../../../shared/hooks/useTranslation";
import { formatClockTime } from "./clock";

export interface OfflineStripProps {
  /** epoch ms of the last successful load; renders a mono "cached HH:mm" readout when present. */
  cachedAt?: number;
}

export function OfflineStrip({ cachedAt }: OfflineStripProps) {
  const { translate } = useTranslation("public");
  return (
    <div
      style={{
        flexShrink: 0,
        position: "sticky",
        top: 50,
        zIndex: 9,
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 14px",
        background: "color-mix(in oklab, var(--amber) 14%, var(--card))",
        borderBottom: "1px solid color-mix(in oklab, var(--amber) 36%, var(--border))",
      }}
    >
      <span style={{ color: "var(--amber)", fontSize: 13 }}>{"⚠"}</span>
      <span style={{ fontSize: 12, fontWeight: 600, color: "var(--ink-2)", flex: 1 }}>
        {translate("kioskV2Offline")}
      </span>
      {cachedAt != null && (
        <span style={{ fontFamily: "var(--font-mono)", fontSize: 9.5, color: "var(--muted)" }}>
          {translate("kioskV2CachedAt", { time: formatClockTime(cachedAt) })}
        </span>
      )}
    </div>
  );
}

export default OfflineStrip;
